import SocketIO from '~/infra/socket';

export const makeSocket = () => SocketIO;
